var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { checkIsPlatform, getTestId, isValidObject, Pagination } from '@airtel/air-design-system';
import debounce from 'lodash/debounce';
import { useEffect, useState } from 'react';
import { ScrollView, View } from 'react-native';
import { ButtonWidgetComponent as ButtonWidget } from '../button-widget/ButtonWidget';
import { DropdownWidgetComponent as DropdownWidget } from '../dropdown-widget/DropdownWidget';
import TableDatePicker from './components/date-picker/TableDatePicker';
import SearchBar from './components/search-bar/SearchBar';
import { Table } from './components/table/Table';
import { NUMBER_NEGATIVE_ONE, NUMBER_ZERO } from './TableWidgetConstants';
import { getDropdownWidgetStyles, getTableWidgetStyles } from './TableWidgetStyles';
import { checkDateInRange, checkFilterDate, convertToTimestamp, findMatchInTableCell } from './TableWidgetUtils';
export var TableWidgetComponent = props => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var id = props.id,
    topButtonWidgetProps = props.topButtonWidgetProps,
    _onUserAction = props.onUserAction,
    onCtaPressMetaData = props.onCtaPressMetaData,
    onHeadingPressMetaData = props.onHeadingPressMetaData,
    onSubHeadingPressMetaData = props.onSubHeadingPressMetaData,
    onHeaderIconPressMetaData = props.onHeaderIconPressMetaData,
    onActionIconPressMetaData = props.onActionIconPressMetaData,
    onDropdownItemPressMetaData = props.onDropdownItemPressMetaData,
    style = props.style,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'TableWidget' : _props$testID,
    _props$filterProps = props.filterProps,
    filterProps = _props$filterProps === void 0 ? {} : _props$filterProps,
    bottomButtonWidgetProps = props.bottomButtonWidgetProps,
    _props$list = props.list,
    list = _props$list === void 0 ? [] : _props$list,
    paginationProps = props.paginationProps,
    onSingleRowCheckboxPressMetaData = props.onSingleRowCheckboxPressMetaData,
    onRadioPressMetaData = props.onRadioPressMetaData,
    onSelectAllPressMetaData = props.onSelectAllPressMetaData,
    _props$clientSideRend = props.clientSideRendering,
    clientSideRendering = _props$clientSideRend === void 0 ? true : _props$clientSideRend,
    scrollViewProps = props.scrollViewProps,
    _props$initialTableDa = props.initialTableData,
    initialTableData = _props$initialTableDa === void 0 ? {} : _props$initialTableDa;
  var tableWidgetStyles = getTableWidgetStyles();
  var dropdownWidgetStyles = getDropdownWidgetStyles();
  var _filterProps$searchFi = filterProps.searchFilterProps,
    searchFilterProps = _filterProps$searchFi === void 0 ? {} : _filterProps$searchFi,
    _filterProps$dateFilt = filterProps.dateFilterProps,
    dateFilterProps = _filterProps$dateFilt === void 0 ? {} : _filterProps$dateFilt;
  var searchBarProps = searchFilterProps.searchBarProps;
  var dateWidgetProps = dateFilterProps.dateWidgetProps;
  var positionSearchBarAtStart = !!searchBarProps && !(searchBarProps === null || searchBarProps === void 0 ? void 0 : searchBarProps.showSearchBarAtEnd);
  var positionSearchBarAtEnd = !!searchBarProps && (searchBarProps === null || searchBarProps === void 0 ? void 0 : searchBarProps.showSearchBarAtEnd);
  var positionDropdownSearchBarAtStart = !!((_a = searchFilterProps === null || searchFilterProps === void 0 ? void 0 : searchFilterProps.dropdownSearchBarProps) === null || _a === void 0 ? void 0 : _a.showDropdownSearchBarAtStart);
  var _useState = useState(list),
    finalTableDataList = _useState[0],
    setFinalTableDataList = _useState[1];
  var _useState2 = useState([]),
    dropdownFilterArray = _useState2[0],
    setDropdownFilterArray = _useState2[1];
  var _useState3 = useState({}),
    dropdownSearchBarProps = _useState3[0],
    setDropdownSearchBarProps = _useState3[1];
  var _useState4 = useState([]),
    selectedCheckboxesData = _useState4[0],
    setSelectedCheckboxesData = _useState4[1];
  var _useState5 = useState((_b = paginationProps === null || paginationProps === void 0 ? void 0 : paginationProps.selectedPageCountIndex) !== null && _b !== void 0 ? _b : NUMBER_ZERO),
    selectedPageIndex = _useState5[0],
    setSelectedPageIndex = _useState5[1];
  var _useState6 = useState((paginationProps === null || paginationProps === void 0 ? void 0 : paginationProps.numberOfRows) || +((_d = (_c = paginationProps === null || paginationProps === void 0 ? void 0 : paginationProps.dropdownList) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.value) || 10),
    selectedPageSize = _useState6[0],
    setSelectedPageSize = _useState6[1];
  var _useState7 = useState(false),
    isValueSearched = _useState7[0],
    setIsValueSearched = _useState7[1];
  var _useState8 = useState(initialTableData),
    tableData = _useState8[0],
    setTableData = _useState8[1];
  var _l = topButtonWidgetProps || {},
    _l$style = _l.style,
    topButtonStyle = _l$style === void 0 ? {} : _l$style,
    _l$alignCTAonLeft = _l.alignCTAonLeft,
    alignCTAonLeft = _l$alignCTAonLeft === void 0 ? false : _l$alignCTAonLeft,
    otherTopButtonWidgetProps = __rest(_l, ["style", "alignCTAonLeft"]);
  useEffect(() => {
    setFinalTableDataList(list);
    setTableData(prev => Object.assign(Object.assign({}, prev), {
      list
    }));
  }, [JSON.stringify(list)]);
  useEffect(() => {
    setDropdownFilterArray(filterProps.dropdownFilterArray);
    setTableData(prev => Object.assign(Object.assign({}, prev), {
      dropdownFilterArray: []
    }));
  }, [JSON.stringify(filterProps.dropdownFilterArray)]);
  useEffect(() => {
    setDropdownSearchBarProps(searchFilterProps.dropdownSearchBarProps);
    setTableData(prev => Object.assign(Object.assign({}, prev), {
      search: []
    }));
  }, [JSON.stringify(searchFilterProps === null || searchFilterProps === void 0 ? void 0 : searchFilterProps.dropdownSearchBarProps)]);
  useEffect(() => {
    setTableData(prev => Object.assign(Object.assign({}, prev), {
      pageIndex: selectedPageIndex
    }));
  }, [selectedPageIndex]);
  useEffect(() => {
    if (Object.keys(initialTableData).length > 0) setTableData(initialTableData);
  }, [initialTableData]);
  var tableSearchBarCallBackHandler = (text, rest) => {
    var _a, _b;
    var childInputProps,
      tempTableData = tableData;
    var parentItem = rest === null || rest === void 0 ? void 0 : rest.parentItem;
    if (parentItem === null || parentItem === void 0 ? void 0 : parentItem.childInputProps) {
      childInputProps = parentItem === null || parentItem === void 0 ? void 0 : parentItem.childInputProps;
    }
    var filterByDropdown = (_a = childInputProps === null || childInputProps === void 0 ? void 0 : childInputProps.filterByDropdown) !== null && _a !== void 0 ? _a : (searchBarProps === null || searchBarProps === void 0 ? void 0 : searchBarProps.id) || 'Search';
    if ((text === null || text === void 0 ? void 0 : text.length) === 0) {
      var newSearchArray = tableData.search.filter(obj => !(filterByDropdown in obj));
      tempTableData = Object.assign(Object.assign({}, tableData), {
        list: list,
        pageIndex: NUMBER_ZERO,
        search: [...newSearchArray]
      });
      setSelectedPageIndex(NUMBER_ZERO);
      setTableData(tempTableData);
      setIsValueSearched(false);
      clientSideRendering && setFinalTableDataList(list);
    } else if ((parentItem === null || parentItem === void 0 ? void 0 : parentItem.childInputProps) && isValidObject(childInputProps) && ((childInputProps === null || childInputProps === void 0 ? void 0 : childInputProps.filterByDropdown) || (childInputProps === null || childInputProps === void 0 ? void 0 : childInputProps.onChangeTextMeta))) {
      if (clientSideRendering) {
        setSelectedPageIndex(NUMBER_ZERO);
        var filteredData = finalTableDataList.reduce((finalList, singleItem) => {
          var _a;
          var checkSingleRowMatchesFilter = false;
          var dataIndex = (_a = props === null || props === void 0 ? void 0 : props.header) === null || _a === void 0 ? void 0 : _a.findIndex(tableHeader => (tableHeader === null || tableHeader === void 0 ? void 0 : tableHeader.id) === (childInputProps === null || childInputProps === void 0 ? void 0 : childInputProps.filterByDropdown));
          if ((childInputProps === null || childInputProps === void 0 ? void 0 : childInputProps.filterByDropdown) && dataIndex !== NUMBER_NEGATIVE_ONE) {
            if (singleItem[dataIndex]) {
              if (findMatchInTableCell(singleItem[dataIndex], text)) {
                checkSingleRowMatchesFilter = true;
              }
            }
          } else {
            var shouldSkip = false;
            singleItem.forEach(val => {
              checkSingleRowMatchesFilter = true;
              if (findMatchInTableCell(val, text)) {
                if (checkSingleRowMatchesFilter && shouldSkip === false) {
                  return finalList = [...finalList, singleItem];
                }
                shouldSkip = true;
              }
            });
          }
          if ((childInputProps === null || childInputProps === void 0 ? void 0 : childInputProps.filterByDropdown) && dataIndex !== NUMBER_NEGATIVE_ONE) {
            if (checkSingleRowMatchesFilter) {
              return finalList = [...finalList, singleItem];
            } else {
              return finalList = [...finalList];
            }
          } else {
            return finalList;
          }
        }, []);
        setFinalTableDataList(filteredData);
        setTableData(prev => {
          tempTableData = Object.assign(Object.assign({}, prev), {
            list: filteredData,
            search: [{
              [filterByDropdown !== null && filterByDropdown !== void 0 ? filterByDropdown : childInputProps === null || childInputProps === void 0 ? void 0 : childInputProps.placeholder]: text
            }]
          });
          return tempTableData;
        });
      }
      tempTableData = Object.assign(Object.assign({}, tableData), {
        search: [{
          [filterByDropdown !== null && filterByDropdown !== void 0 ? filterByDropdown : childInputProps === null || childInputProps === void 0 ? void 0 : childInputProps.placeholder]: [{
            value: text
          }]
        }],
        pageIndex: NUMBER_ZERO
      });
      setTableData(tempTableData);
      setIsValueSearched(true);
      setSelectedPageIndex(NUMBER_ZERO);
    } else {
      setIsValueSearched(true);
      if (clientSideRendering) {
        setSelectedPageIndex(NUMBER_ZERO);
        var _filteredData = list.reduce((finalList, singleItem) => {
          var _a;
          var checkSingleRowMatchesFilter = false;
          for (var i = 0; i < (singleItem === null || singleItem === void 0 ? void 0 : singleItem.length); i++) {
            if (searchFilterProps === null || searchFilterProps === void 0 ? void 0 : searchFilterProps.filterByColumnId) {
              if (((_a = singleItem[i]) === null || _a === void 0 ? void 0 : _a.id) === (searchFilterProps === null || searchFilterProps === void 0 ? void 0 : searchFilterProps.filterByColumnId)) {
                if (findMatchInTableCell(singleItem[i], text)) {
                  checkSingleRowMatchesFilter = true;
                  break;
                }
              }
            } else {
              if (findMatchInTableCell(singleItem[i], text)) {
                checkSingleRowMatchesFilter = true;
                break;
              }
            }
          }
          if (checkSingleRowMatchesFilter) {
            return finalList = [...finalList, singleItem];
          } else {
            return finalList = [...finalList];
          }
        }, []);
        setFinalTableDataList(_filteredData);
        tempTableData = Object.assign(Object.assign({}, tableData), {
          list: _filteredData,
          pageIndex: NUMBER_ZERO
        });
      } else {
        var _newSearchArray = tableData.search.filter(obj => {
          var _a;
          return !(((_a = searchBarProps === null || searchBarProps === void 0 ? void 0 : searchBarProps.id) !== null && _a !== void 0 ? _a : 'Search') in obj);
        });
        tempTableData = Object.assign(Object.assign({}, tableData), {
          search: [..._newSearchArray, {
            [(_b = searchBarProps === null || searchBarProps === void 0 ? void 0 : searchBarProps.id) !== null && _b !== void 0 ? _b : 'Search']: [{
              value: text
            }]
          }],
          pageIndex: NUMBER_ZERO
        });
        setTableData(tempTableData);
        setIsValueSearched(true);
        setSelectedPageIndex(NUMBER_ZERO);
      }
    }
    (childInputProps === null || childInputProps === void 0 ? void 0 : childInputProps.onChangeTextMeta) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, childInputProps === null || childInputProps === void 0 ? void 0 : childInputProps.onChangeTextMeta), {
      text,
      filterByDropdown,
      tableData: tempTableData
    }));
    (searchBarProps === null || searchBarProps === void 0 ? void 0 : searchBarProps.onChangeTextMeta) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, searchBarProps === null || searchBarProps === void 0 ? void 0 : searchBarProps.onChangeTextMeta), {
      text,
      tableData: tempTableData
    }));
  };
  var onClearButtonClick = () => {
    setFinalTableDataList(list);
    setTableData(prev => Object.assign(Object.assign({}, prev), {
      list
    }));
  };
  var dateFilterCallBackHandler = function dateFilterCallBackHandler(date, tableCellPropForFilter, isServerSideFilteringEnabled, columnId, mode, onDateRangeChangeMetaData) {
    if (tableCellPropForFilter === void 0) {
      tableCellPropForFilter = 'heading';
    }
    if (isServerSideFilteringEnabled === void 0) {
      isServerSideFilteringEnabled = false;
    }
    if (isServerSideFilteringEnabled) {
      switch (mode) {
        case "date-range":
          {
            if (date[0] && date[1]) {
              var tempTableData = Object.assign(Object.assign({}, tableData), {
                pageIndex: NUMBER_ZERO
              });
              setTableData(tempTableData);
              setSelectedPageIndex(NUMBER_ZERO);
              var timestamp = {
                startDate: convertToTimestamp(date[0]),
                endDate: convertToTimestamp(date[1])
              };
              onDateRangeChangeMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
                id
              }, onDateRangeChangeMetaData), {
                timestamp,
                date,
                columnId,
                tableCellPropForFilter,
                tableData: tempTableData
              }));
            }
            break;
          }
        default:
          {
            onDateRangeChangeMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
              id
            }, onDateRangeChangeMetaData), {
              date,
              columnId,
              tableCellPropForFilter
            }));
          }
      }
    } else {
      switch (mode) {
        case "date-range":
          {
            if (date[0] && date[1]) {
              var filteredDateRangeDate = list === null || list === void 0 ? void 0 : list.reduce((finalList, singleItem) => {
                var _a;
                var checkSingleRowMatchesFilter = false;
                for (var i = 0; i < (singleItem === null || singleItem === void 0 ? void 0 : singleItem.length); i++) {
                  if (columnId) {
                    if (((_a = singleItem[i]) === null || _a === void 0 ? void 0 : _a.id) === columnId) {
                      if (checkDateInRange(singleItem[i], tableCellPropForFilter, date[0], date[1])) {
                        checkSingleRowMatchesFilter = true;
                        break;
                      }
                    }
                  }
                }
                if (checkSingleRowMatchesFilter) {
                  return finalList = [...finalList, singleItem];
                } else {
                  return finalList = [...finalList];
                }
              }, []);
              setFinalTableDataList(filteredDateRangeDate);
              setTableData(prev => Object.assign(Object.assign({}, prev), {
                list: filteredDateRangeDate
              }));
            }
            break;
          }
        default:
          {
            var filteredDateDate = list === null || list === void 0 ? void 0 : list.reduce((finalList, singleItem) => {
              var _a;
              var checkSingleRowMatchesFilter = false;
              for (var i = 0; i < (singleItem === null || singleItem === void 0 ? void 0 : singleItem.length); i++) {
                if (columnId) {
                  if (((_a = singleItem[i]) === null || _a === void 0 ? void 0 : _a.id) === columnId) {
                    if (checkFilterDate(singleItem[i], tableCellPropForFilter, date)) {
                      checkSingleRowMatchesFilter = true;
                      break;
                    }
                  }
                }
              }
              if (checkSingleRowMatchesFilter) {
                return finalList = [...finalList, singleItem];
              } else {
                return finalList = [...finalList];
              }
            }, []);
            setFinalTableDataList(filteredDateDate);
            setTableData(prev => Object.assign(Object.assign({}, prev), {
              list: filteredDateDate
            }));
          }
      }
    }
  };
  var onPaginationPageChange = data => {
    var _a;
    var tempTableData = Object.assign(Object.assign({}, tableData), {
      pageIndex: (data === null || data === void 0 ? void 0 : data.index) || NUMBER_ZERO
    });
    setTableData(tempTableData);
    (paginationProps === null || paginationProps === void 0 ? void 0 : paginationProps.onPageChangeMetaData) && (paginationProps === null || paginationProps === void 0 ? void 0 : paginationProps.onPageChangeMetaData) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, paginationProps === null || paginationProps === void 0 ? void 0 : paginationProps.onPageChangeMetaData), Object.assign(Object.assign({}, data), {
      tableData: tempTableData
    })));
    setSelectedPageIndex((data === null || data === void 0 ? void 0 : data.index) || NUMBER_ZERO);
    (_a = paginationProps === null || paginationProps === void 0 ? void 0 : paginationProps.onPageChange) === null || _a === void 0 ? void 0 : _a.call(paginationProps, data);
  };
  var onPaginationDrowndownChange = data => {
    setSelectedPageSize(+(data === null || data === void 0 ? void 0 : data.value) || 10);
  };
  var getPaginatedData = data => {
    var _ref = paginationProps || {},
      totalPaginationDataCount = _ref.totalPaginationDataCount,
      _ref$isServerSidePagi = _ref.isServerSidePagination,
      isServerSidePagination = _ref$isServerSidePagi === void 0 ? false : _ref$isServerSidePagi;
    var startPageCount = isValueSearched ? 0 : selectedPageSize * selectedPageIndex;
    var endPageCount = selectedPageSize * selectedPageIndex + selectedPageSize;
    if (isServerSidePagination && totalPaginationDataCount) {
      startPageCount = startPageCount % totalPaginationDataCount;
      endPageCount = startPageCount + selectedPageSize;
    }
    return data === null || data === void 0 ? void 0 : data.slice(startPageCount, endPageCount);
  };
  var handleSelectAll = data => {
    if ((selectedCheckboxesData === null || selectedCheckboxesData === void 0 ? void 0 : selectedCheckboxesData.length) === 0) setSelectedCheckboxesData(data === null || data === void 0 ? void 0 : data.listData);else setSelectedCheckboxesData([]);
  };
  var onSelectDropdownValue = (_a, _b, dropdownProps) => {
    var _c, _d, _e, _f, _g;
    var id = _a.id,
      onSelectMetaData = __rest(_a, ["id"]);
    var data = _b.data,
      searchedTerm = _b.searchedTerm,
      item = _b.item;
    var tempTableData = tableData;
    if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
      if ((item === null || item === void 0 ? void 0 : item.childType) || (item === null || item === void 0 ? void 0 : item.childInputProps) || (item === null || item === void 0 ? void 0 : item.childDropDownProps) || (item === null || item === void 0 ? void 0 : item.parentItem)) {
        if ((item === null || item === void 0 ? void 0 : item.childType) || (item === null || item === void 0 ? void 0 : item.childInputProps)) {
          if (item === null || item === void 0 ? void 0 : item.childInputProps) {
            tempTableData = Object.assign(Object.assign({}, tableData), {
              search: [],
              pageIndex: NUMBER_ZERO
            });
            onSelectMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
              id
            }, onSelectMetaData), {
              data,
              searchedTerm,
              filterByDropdown: dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.filterByDropdown,
              tableData: tempTableData
            }));
            setTableData(tempTableData);
            clientSideRendering && setFinalTableDataList(list);
            setSelectedPageIndex(NUMBER_ZERO);
          } else {
            tempTableData = Object.assign(Object.assign({}, tableData), {
              search: [],
              pageIndex: NUMBER_ZERO
            });
            onSelectMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
              id
            }, onSelectMetaData), {
              data,
              searchedTerm,
              filterByDropdown: dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.filterByDropdown,
              tableData: tempTableData
            }));
            setTableData(tempTableData);
            clientSideRendering && setFinalTableDataList(list);
            setSelectedPageIndex(NUMBER_ZERO);
          }
        } else if (item === null || item === void 0 ? void 0 : item.parentItem) {
          setSelectedPageIndex(NUMBER_ZERO);
          var customDropdownProps = item === null || item === void 0 ? void 0 : item.parentItem;
          var childDropdown = customDropdownProps === null || customDropdownProps === void 0 ? void 0 : customDropdownProps.childDropDownProps;
          var filterByDropdown = childDropdown === null || childDropdown === void 0 ? void 0 : childDropdown.filterByDropdown;
          tempTableData = Object.assign(Object.assign({}, tableData), {
            search: [{
              [filterByDropdown]: data
            }],
            pageIndex: NUMBER_ZERO
          });
          setTableData(tempTableData);
          (childDropdown === null || childDropdown === void 0 ? void 0 : childDropdown.onSelectMetaData) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, childDropdown === null || childDropdown === void 0 ? void 0 : childDropdown.onSelectMetaData), {
            data,
            searchedTerm,
            filterByDropdown,
            tableData: tempTableData
          }));
        }
      } else {
        setSelectedPageIndex(NUMBER_ZERO);
        var _filterByDropdown = dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.filterByDropdown;
        var tempDropdownFilterArray = (_c = tableData.dropdownFilterArray) === null || _c === void 0 ? void 0 : _c.filter(obj => !(_filterByDropdown in obj));
        if (clientSideRendering) {
          var filterKey = dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.filterKey;
          var filteredData = list && list.filter(singleItem => {
            return singleItem.some(cell => {
              if ((dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.filterByDropdown) && (cell === null || cell === void 0 ? void 0 : cell.id) === (dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.filterByDropdown)) {
                return data.some(selectedItem => {
                  var _a;
                  return selectedItem.isSelected && selectedItem[filterKey].toLowerCase() === ((_a = cell[dropdownProps.filterOnTableCellProp]) === null || _a === void 0 ? void 0 : _a.toLowerCase());
                });
              }
              return false;
            });
          });
          filteredData && setFinalTableDataList(filteredData);
        }
        tempTableData = Object.assign(Object.assign({}, tableData), {
          dropdownFilterArray: [...tempDropdownFilterArray, {
            [_filterByDropdown]: data
          }],
          pageIndex: NUMBER_ZERO
        });
        setTableData(tempTableData);
        onSelectMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
          id
        }, onSelectMetaData), {
          data,
          searchedTerm,
          filterByDropdown: _filterByDropdown,
          tableData: tempTableData
        }));
      }
    } else {
      var _customDropdownProps = item === null || item === void 0 ? void 0 : item.parentItem;
      var _childDropdown = _customDropdownProps === null || _customDropdownProps === void 0 ? void 0 : _customDropdownProps.childDropDownProps;
      setSelectedPageIndex(NUMBER_ZERO);
      if (item === null || item === void 0 ? void 0 : item.childInputProps) {
        var _filterByDropdown2 = (_d = item === null || item === void 0 ? void 0 : item.childInputProps) === null || _d === void 0 ? void 0 : _d.filterByDropdown;
        var newDropdownFilterArray = tableData.search.filter(obj => !(_filterByDropdown2 in obj));
        tempTableData = Object.assign(Object.assign({}, tableData), {
          search: [...newDropdownFilterArray],
          pageIndex: NUMBER_ZERO
        });
        setTableData(tempTableData);
        onSelectMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
          id
        }, onSelectMetaData), {
          data,
          searchedTerm,
          item,
          tableData: tempTableData
        }));
        return;
      } else if ((item === null || item === void 0 ? void 0 : item.childDropDownProps) || _childDropdown) {
        var _filterByDropdown3 = (_e = _childDropdown === null || _childDropdown === void 0 ? void 0 : _childDropdown.filterByDropdown) !== null && _e !== void 0 ? _e : (_f = item === null || item === void 0 ? void 0 : item.childDropDownProps) === null || _f === void 0 ? void 0 : _f.filterByDropdown;
        var _newDropdownFilterArray = tableData.search.filter(obj => !(_filterByDropdown3 in obj));
        tempTableData = Object.assign(Object.assign({}, tableData), {
          search: [..._newDropdownFilterArray],
          pageIndex: NUMBER_ZERO
        });
        setTableData(tempTableData);
        if ((_g = item === null || item === void 0 ? void 0 : item.childDropDownProps) === null || _g === void 0 ? void 0 : _g.filterByDropdown) {
          (_childDropdown === null || _childDropdown === void 0 ? void 0 : _childDropdown.onSelectMetaData) && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, _childDropdown === null || _childDropdown === void 0 ? void 0 : _childDropdown.onSelectMetaData), {
            data,
            searchedTerm,
            item,
            tableData: tempTableData
          }));
        } else {
          onSelectMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onSelectMetaData), {
            data,
            searchedTerm,
            item,
            tableData: tempTableData
          }));
        }
        return;
      } else {
        var _filterByDropdown4 = dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.filterByDropdown;
        var _newDropdownFilterArray2 = tableData.dropdownFilterArray.filter(obj => !(_filterByDropdown4 in obj));
        tempTableData = Object.assign(Object.assign({}, tableData), {
          dropdownFilterArray: [..._newDropdownFilterArray2],
          pageIndex: NUMBER_ZERO
        });
        setTableData(tempTableData);
      }
      onSelectMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
        id
      }, onSelectMetaData), {
        data,
        searchedTerm,
        filterByDropdown: dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.filterByDropdown,
        tableData: tempTableData
      }));
      setFinalTableDataList(list);
    }
  };
  var onRadioPressHandler = (selectedIndex, data) => {
    var selectedFieldData = data === null || data === void 0 ? void 0 : data[selectedIndex];
    onRadioPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, onRadioPressMetaData), {
      selectedFieldData,
      data
    }));
    setSelectedCheckboxesData([data]);
  };
  var TableWrapper = checkIsPlatform('web') || !((_f = (_e = props === null || props === void 0 ? void 0 : props.header) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.minWidth) ? View : ScrollView;
  return _jsxs(View, Object.assign({
    style: style
  }, getTestId(testID), {
    children: [(isValidObject(searchBarProps) || isValidObject(dropdownSearchBarProps) || isValidObject(dateWidgetProps) || isValidObject(otherTopButtonWidgetProps) || (dropdownFilterArray === null || dropdownFilterArray === void 0 ? void 0 : dropdownFilterArray.length) > 0) && _jsxs(View, Object.assign({
      style: tableWidgetStyles.filterContainerWrapper
    }, {
      children: [(positionSearchBarAtStart || !!dateWidgetProps || (dropdownFilterArray === null || dropdownFilterArray === void 0 ? void 0 : dropdownFilterArray.length) > 0 || positionDropdownSearchBarAtStart || alignCTAonLeft && !!otherTopButtonWidgetProps) && _jsxs(View, Object.assign({
        style: tableWidgetStyles.subActionContainer
      }, {
        children: [positionSearchBarAtStart && _jsx(SearchBar, Object.assign({
          onTextChangeHandler: debounce(tableSearchBarCallBackHandler, (_g = searchFilterProps === null || searchFilterProps === void 0 ? void 0 : searchFilterProps.debounceTimeout) !== null && _g !== void 0 ? _g : 500)
        }, searchBarProps)), !!dateWidgetProps && _jsx(TableDatePicker, Object.assign({}, dateFilterProps, {
          dateFilterCallBackHandler: dateFilterCallBackHandler,
          onClearButtonClick: onClearButtonClick,
          onUserAction: _onUserAction
        })), dropdownFilterArray === null || dropdownFilterArray === void 0 ? void 0 : dropdownFilterArray.map((dropdownProps, index) => _jsx(View, Object.assign({
          style: dropdownWidgetStyles.dropdownContainer
        }, {
          children: _jsx(View, Object.assign({
            style: [dropdownWidgetStyles.dropdownWrapper, dropdownProps.dropdownWrapperStyle]
          }, {
            children: _jsx(DropdownWidget, Object.assign({}, dropdownProps, {
              dropdownMenuStyles: [dropdownWidgetStyles.dropdownMenuStyle, dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.dropdownMenuStyles],
              onUserAction: (_a, _b) => {
                var id = _a.id,
                  onSelectMetaData = __rest(_a, ["id"]);
                var data = _b.data,
                  searchedTerm = _b.searchedTerm,
                  item = _b.item;
                return onSelectDropdownValue(Object.assign({
                  id
                }, onSelectMetaData), {
                  data,
                  searchedTerm,
                  item
                }, dropdownProps);
              }
            }))
          }))
        }), index + "key")), !!dropdownSearchBarProps && positionDropdownSearchBarAtStart && (dropdownSearchBarProps === null || dropdownSearchBarProps === void 0 ? void 0 : dropdownSearchBarProps.showChildDropDown) && _jsx(View, Object.assign({
          style: dropdownWidgetStyles.dropdownContainer
        }, {
          children: _jsx(View, Object.assign({
            style: [dropdownWidgetStyles.dropdownWrapper, dropdownSearchBarProps.dropdownWrapperStyle]
          }, {
            children: _jsx(DropdownWidget, Object.assign({}, dropdownSearchBarProps, {
              onUserAction: (_a, _b) => {
                var id = _a.id,
                  onSelectMetaData = __rest(_a, ["id"]);
                var data = _b.data,
                  searchedTerm = _b.searchedTerm,
                  item = _b.item;
                onSelectDropdownValue(Object.assign({
                  id
                }, onSelectMetaData), {
                  data,
                  searchedTerm,
                  item
                }, dropdownSearchBarProps);
              },
              onChangeText: debounce(tableSearchBarCallBackHandler, (_h = searchFilterProps === null || searchFilterProps === void 0 ? void 0 : searchFilterProps.debounceTimeout) !== null && _h !== void 0 ? _h : 500),
              dropdownMenuStyles: [dropdownWidgetStyles.dropdownMenuStyle, dropdownSearchBarProps === null || dropdownSearchBarProps === void 0 ? void 0 : dropdownSearchBarProps.dropdownMenuStyles],
              style: [dropdownWidgetStyles === null || dropdownWidgetStyles === void 0 ? void 0 : dropdownWidgetStyles.dropdownStyle, dropdownSearchBarProps === null || dropdownSearchBarProps === void 0 ? void 0 : dropdownSearchBarProps.style],
              childStyle: [dropdownWidgetStyles === null || dropdownWidgetStyles === void 0 ? void 0 : dropdownWidgetStyles.childDropdownStyle, dropdownSearchBarProps === null || dropdownSearchBarProps === void 0 ? void 0 : dropdownSearchBarProps.childStyle]
            }))
          }))
        }), "dropdownSearchBarKey"), !!otherTopButtonWidgetProps && alignCTAonLeft && _jsx(ButtonWidget, Object.assign({
          style: positionSearchBarAtStart || !!dateWidgetProps || (dropdownFilterArray === null || dropdownFilterArray === void 0 ? void 0 : dropdownFilterArray.length) > 0 ? [tableWidgetStyles.buttonWidgetStyle, topButtonStyle] : topButtonStyle,
          onUserAction: _onUserAction
        }, otherTopButtonWidgetProps))]
      })), (!!dropdownSearchBarProps && !positionDropdownSearchBarAtStart && (dropdownSearchBarProps === null || dropdownSearchBarProps === void 0 ? void 0 : dropdownSearchBarProps.showChildDropDown) || positionSearchBarAtEnd || !!otherTopButtonWidgetProps && !alignCTAonLeft) && _jsxs(View, Object.assign({
        style: tableWidgetStyles.searchContainerWrapper
      }, {
        children: [positionSearchBarAtEnd && _jsx(SearchBar, Object.assign({
          onTextChangeHandler: debounce(tableSearchBarCallBackHandler, (_j = searchFilterProps === null || searchFilterProps === void 0 ? void 0 : searchFilterProps.debounceTimeout) !== null && _j !== void 0 ? _j : 500)
        }, searchBarProps)), !!dropdownSearchBarProps && !positionDropdownSearchBarAtStart && (dropdownSearchBarProps === null || dropdownSearchBarProps === void 0 ? void 0 : dropdownSearchBarProps.showChildDropDown) && _jsx(View, Object.assign({
          style: dropdownWidgetStyles.dropdownContainer
        }, {
          children: _jsx(View, Object.assign({
            style: [dropdownWidgetStyles.dropdownWrapper, dropdownSearchBarProps.dropdownWrapperStyle]
          }, {
            children: _jsx(DropdownWidget, Object.assign({}, dropdownSearchBarProps, {
              onUserAction: (_a, _b) => {
                var id = _a.id,
                  onSelectMetaData = __rest(_a, ["id"]);
                var data = _b.data,
                  searchedTerm = _b.searchedTerm,
                  item = _b.item;
                onSelectDropdownValue(Object.assign({
                  id
                }, onSelectMetaData), {
                  data,
                  searchedTerm,
                  item
                }, dropdownSearchBarProps);
              },
              onChangeText: debounce(tableSearchBarCallBackHandler, (_k = searchFilterProps === null || searchFilterProps === void 0 ? void 0 : searchFilterProps.debounceTimeout) !== null && _k !== void 0 ? _k : 500),
              dropdownMenuStyles: [dropdownWidgetStyles.dropdownMenuStyle, dropdownSearchBarProps === null || dropdownSearchBarProps === void 0 ? void 0 : dropdownSearchBarProps.dropdownMenuStyles],
              style: [dropdownWidgetStyles === null || dropdownWidgetStyles === void 0 ? void 0 : dropdownWidgetStyles.dropdownStyle, dropdownSearchBarProps === null || dropdownSearchBarProps === void 0 ? void 0 : dropdownSearchBarProps.style],
              childStyle: [dropdownWidgetStyles === null || dropdownWidgetStyles === void 0 ? void 0 : dropdownWidgetStyles.childDropdownStyle, dropdownSearchBarProps === null || dropdownSearchBarProps === void 0 ? void 0 : dropdownSearchBarProps.childStyle]
            }))
          }))
        }), "dropdownSearchBarKey"), !!otherTopButtonWidgetProps && !alignCTAonLeft && _jsx(ButtonWidget, Object.assign({
          style: [tableWidgetStyles.endButtonWidgetStyle, topButtonStyle],
          onUserAction: _onUserAction
        }, otherTopButtonWidgetProps))]
      }))]
    })), _jsx(TableWrapper, Object.assign({}, !checkIsPlatform('web') && Object.assign(Object.assign({}, scrollViewProps), {
      horizontal: true
    }), {
      children: _jsx(Table, Object.assign({}, props, {
        tableData: tableData,
        list: clientSideRendering ? getPaginatedData(finalTableDataList) : finalTableDataList,
        setFinalTableDataList: setFinalTableDataList,
        setSelectedPageIndex: setSelectedPageIndex,
        totalData: list,
        onCtaPress: data => {
          var _a;
          (_a = props === null || props === void 0 ? void 0 : props.onCtaPress) === null || _a === void 0 ? void 0 : _a.call(props, data);
          onCtaPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onCtaPressMetaData), Object.assign(Object.assign({}, props), {
            selectedData: data
          })));
        },
        onHeadingPress: data => {
          var _a;
          (_a = props === null || props === void 0 ? void 0 : props.onHeadingPress) === null || _a === void 0 ? void 0 : _a.call(props, data);
          onHeadingPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onHeadingPressMetaData), Object.assign(Object.assign({}, props), {
            selectedData: data
          })));
        },
        onSubHeadingPress: data => {
          var _a;
          (_a = props === null || props === void 0 ? void 0 : props.onSubHeadingPress) === null || _a === void 0 ? void 0 : _a.call(props, data);
          onSubHeadingPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onSubHeadingPressMetaData), Object.assign(Object.assign({}, props), {
            selectedData: data
          })));
        },
        onHeaderIconPress: data => {
          var _a;
          (_a = props === null || props === void 0 ? void 0 : props.onHeaderIconPress) === null || _a === void 0 ? void 0 : _a.call(props, data);
          onHeaderIconPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onHeaderIconPressMetaData), Object.assign(Object.assign({}, props), {
            headerData: data
          })));
        },
        onActionIconPress: data => {
          var onPress = data.onPress,
            restData = __rest(data, ["onPress"]);
          onPress && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onPress), restData));
          onActionIconPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onActionIconPressMetaData), restData));
        },
        onDropdownItemPress: data => {
          var selectedItem = data.selectedItem;
          var onPress = selectedItem.onPress;
          onPress && _onUserAction(Object.assign({
            id
          }, onPress), data);
          onDropdownItemPressMetaData && _onUserAction(Object.assign({
            id
          }, onDropdownItemPressMetaData), data);
        },
        onSingleRowCheckboxPress: data => {
          var checked = data.checked,
            rowData = data.data;
          onSingleRowCheckboxPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onSingleRowCheckboxPressMetaData), Object.assign({}, data)));
          if (checked) {
            setSelectedCheckboxesData(prevState => [...prevState, rowData]);
          } else {
            setSelectedCheckboxesData(prevState => prevState.filter(item => item !== rowData));
          }
        },
        onRadioPress: (selectedIndex, data) => onRadioPressHandler(selectedIndex, data)
      }, getTestId(testID, 'table'), {
        onSelectAllPress: data => {
          onSelectAllPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onSelectAllPressMetaData), Object.assign({}, data)));
          handleSelectAll(data);
        },
        onUserAction: _onUserAction
      }))
    })), !!paginationProps && _jsx(Pagination, Object.assign({
      selectedDropdownIndex: 2,
      pageCount: Math.ceil((finalTableDataList === null || finalTableDataList === void 0 ? void 0 : finalTableDataList.length) / selectedPageSize),
      selectedPageCountIndex: selectedPageIndex,
      style: {
        zIndex: -1
      }
    }, paginationProps, {
      onPageChange: onPaginationPageChange,
      onDropdownChange: onPaginationDrowndownChange
    })), !!bottomButtonWidgetProps && _jsx(View, Object.assign({
      style: tableWidgetStyles.bottomButtonContainer
    }, {
      children: _jsx(ButtonWidget, Object.assign({}, bottomButtonWidgetProps, {
        onUserAction: (args, extradata) => {
          _onUserAction(args, Object.assign(Object.assign({}, extradata), {
            selectedData: selectedCheckboxesData
          }));
        }
      }))
    }))]
  }));
};
TableWidgetComponent.genericRendererKey = 'AirTableWidget';
TableWidgetComponent.defaultProps = {
  skeletonLoaderProps: {
    fullWidth: true,
    numberOfViews: 1,
    type: 'card-large'
  }
};